import React, {FC} from "react";
import {observer} from "mobx-react"
import './NavHeading.scss';
import {useStorageContext} from "@app/contexts/storage";
import {Typography} from "@mui/material";

const Headings = {
    // [MAIN_PAGE.LOGOUT]: () => <Typography>Login site</Typography>,
    // [MAIN_PAGE.SELF_CONFIG]: () => <Typography>Users site</Typography>,
    // [MAIN_PAGE.USER_CONFIG]: () => <Typography></Typography>,
    // [MAIN_PAGE.TRANSLATE]: () => <Typography>Translation site</Typography>,
    // [MAIN_PAGE.CONFIRM_TRANSLATE]: () => <Typography>Translation confirmation site</Typography>
}

type TProps = {}
export const NavHeading: FC<TProps> = observer(function (props: TProps) {
    const {globalStorage} = useStorageContext();

    const Heading = Headings[globalStorage.openModule] ? Headings[globalStorage.openModule] : () =>
        // <Typography>Page Login</Typography>;
    <Typography></Typography>;

    return <div className={"nav-heading"}>
        <Heading/>
    </div>
})
